<template>
  <base-table-wrapper>
    <template #top-buttons>
      <router-link v-if="ableToCreateDevice" :to="{ name: 'EXCMDeviceCreate' }" class="mb-1 btn btn-sm btn-primary float-right">{{$t('buttons.create')}}</router-link>
    </template>
    <template #filtering>
      <div class="float-right">
        <button type="button"
                class="btn btn-sm fa fa-sync fa-lg btn-link"
                @click="clearFilters()">
        </button>
        <b-button class="btn-sm ml-2" v-b-tooltip.hover :title="$t('buttons.search')"  v-b-toggle.devices_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
      </div>
      <div>
        <b-collapse id="devices_search_collapse" class="mt-2">
          <DevicesFiltering ref="deviceFiltering" :getPage="getPage"></DevicesFiltering>
        </b-collapse>
      </div>
    </template>
    <template #body>
      <Loader v-if="isLoading"></Loader>
      <div v-else-if="!isLoading && items.length < 1">{{ $t('views.excmdevice.list.noDevices') }}</div>
      <table v-else class="table table-sm table-responsive-md">
        <thead>
        <tr>
          <th></th>
          <th>{{$t('views.excmdevice.show.type')}}</th>
          <th>{{$t('views.excmdevice.show.brand')}}</th>
          <th>{{$t('views.excmdevice.show.model')}}</th>
          <th>{{$t('views.excmdevice.show.serialNumber')}}</th>
          <th>{{$t('views.excmdevice.show.localization')}}</th>
          <th>{{$t('views.excmcase.form.contractorUserData')}}</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in items" :key="item['@id']">
          <td>
            <div class="btn btn-link fa fa-qrcode fa-lg" v-if="item" @click="downloadPDF(getIdLink(item['@id']), item.serialNumber)" v-b-tooltip.hover :title="$t('views.excmdevice.show.downloadPDF')">
            </div>
          </td>
          <td>
            {{item.idDeviceModel.idDeviceType.title}}
          </td>
          <td>
            {{item.idDeviceModel.idDeviceBrand.brandTitle}}
          </td>
          <td>
            {{item.idDeviceModel.model}}
          </td>
          <td>{{item.serialNumber}}</td>
          <td>
            <span v-if="item.city">{{item.city}}, </span>
            <span v-if="item.street">{{item.street}} </span>
            <span v-if="item.building">{{item.building}}</span>
          </td>
          <td>
            <span v-if="item.idContractorUserData && item.idContractorUserData.fullName">{{item.idContractorUserData.fullName}}</span>
            <span v-if="item.idContractorUserData && item.idContractorUserData.firmname1">{{item.idContractorUserData.firmname1}}</span>
          </td>
          <td>
            <div class="btn-group float-right">
              <router-link tag="button" class="btn btn-link fa fa-search fa-lg" v-if="item" :to="{name: 'EXCMDeviceShow', params: { id: item['@id'] }}">
              </router-link>
              <router-link tag="button" class="btn btn-link fa fa-edit fa-lg" v-if="item" :to="{name: 'EXCMDeviceUpdate', params: { id: item['@id'] }}">
              </router-link>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <div v-if="view">
        <pagination
          :view="view"
          @getPage="getPage($event)"
        ></pagination>
      </div>
    </template>
  </base-table-wrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission, checkPermission } from '@/utils/checkRoles.js'
import DevicesFiltering from './components/DevicesFiltering/DevicesFiltering'
import Loader from '../../Layout/Loader'
import addParamsToQuery from '@/utils/addParamsToQuery'
import getId from '@/utils/getIdFromLink'
import Pagination from '../../Layout/Pagination'
import Swal from 'sweetalert2'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'

export default {
  components: {
    DevicesFiltering,
    Loader,
    Pagination,
    BaseTableWrapper
  },

  computed: {
    ...mapGetters({
      deletedItem: 'excmdevice/del/deleted',
      error: 'excmdevice/list/error',
      items: 'excmdevice/list/items',
      isLoading: 'excmdevice/list/isLoading',
      view: 'excmdevice/list/view'
    }),
    ableToCreateDevice: function () {
      return this.checkRoles('devices', 'EXCMDeviceCreate')
    },
    mobileView () {
      return this.$store.state.mobileView
    }
  },

  beforeCreate () {
    checkPagePermission('devices', 'EXCMDeviceList')
  },

  data () {
    return {
      searchParams: {
        state: 1
      }
    }
  },

  created () {
    let url = addParamsToQuery('e_x_c_m_devices', this.searchParams)
    this.getPage(url)
    this.channelDevicesRooms = this.$store.state.Pusher.subscribe('e_x_c_m_devices')
    this.channelDevicesRooms.bind('e_x_c_m_devices', data => {
      this.getPage(url)
    })
  },

  destroyed () {
    this.$store.state.Pusher.unsubscribe('e_x_c_m_devices')
  },

  methods: {
    ...mapActions({
      getPage: 'excmdevice/list/default'
    }),

    downloadPDF (id, deviceSerialNumber) {
      this.$http
        .get('api/e_x_c_m_devices/' + id + '/getqrcode', {
          responseType: 'arraybuffer'
        })
        .then(response => {
          var myBlob = new Blob([response.data], { type: 'application/pdf' })
          var url = window.URL.createObjectURL(myBlob)
          var a = document.createElement('a')
          document.body.appendChild(a)
          a.href = url
          let fileName = 'device_' + deviceSerialNumber + '.pdf'
          a.download = fileName // Name file to download
          a.click()
          setTimeout(function () { window.URL.revokeObjectURL(url) }, 0)
        })
        .catch(error => {
          Swal({
            type: 'error',
            title: this.$t('notifications.store.errorTitle') + ' - ' + error,
            showConfirmButton: false,
            timer: 2500
          })
        })
    },
    getIdLink (link) {
      return getId(link)
    },
    checkRoles (type, view = null, component = null) {
      return checkPermission(type, view, component)
    },
    clearFilters () {
      this.$refs.deviceFiltering.clearFilters()
    }
  }
}
</script>
